export const DEFAULT_PAYMENTS_RESPONSE_KEY = "show_payments";

/**
 * Session flag: cart had discount_lottie / discount_lottie_fallback and we yielded once.
 *
 * Written as `true` only when those assets are present (never `false`).
 * - Present + not yet marked → skip web expand this visit (app lottie beat), then mark.
 * - Already marked → web expand may run when savings increase (see key below).
 * - Absent → web expand may run on first paint, then again on savings increases.
 */
export const QUICK_CHECKOUT_APP_ANIMATION_SEEN_SESSION_KEY = "quick_checkout_app_animation_seen";

/**
 * Session baseline for the last `total_discount` observed for the QC header strip.
 *
 * Used to detect savings increases so the web expand sequence can replay within a session.
 * Also set when yielding to the app animation (without playing) so the next higher discount
 * can trigger the strip.
 */
export const QUICK_CHECKOUT_WEB_HEADER_LAST_DISCOUNT_SESSION_KEY =
    "quick_checkout_web_header_last_discount";

// sid key to store in STORAGE to show offer bundle half card once in a session
export const OFFER_BUNDLE_HALF_CARD_SID = "sid_for_which_half_card_is_visible";

/** This key is to store the Auto add XP plan type */
export const AUTO_ADD_OR_ONE_TAP_PLAN_TYPE_SESSION_KEY = "auto_add_or_one_tap_plan_session_key";

export const IS_IRCTC_CART_SESSION_KEY = "is_irctc_cart_session_key";

// sid to store the session id for which the one membership gratification is shown
export const ONE_MEMBERSHIP_GRATIFICATION_SID = "gratification_modal_sid";

export const ONE_MEMBERSHIP_PLAN_ADDITION_CONFETTI_SID = "one_membership_plan_addition_confetti_sid";

// localStorage key used by web-bridge-sdk for mweb cart
export const SWGY_PWA_CART_DATA = "swgy_pwa_cartData";
export const WEB_FOOD_CART_LOCAL = "web_food_cart_local";
